import http from '@core/assets/js/helpers/http'
/**
 *
 */
class BaseClient
{
	/**
	 * I'm the constructor
	 */
	constructor() {
		this.defaults = {
			method: 'GET',
			apiBase: this.settings().api.url,
			url: '',
			callback: response => {
				console.log(response)
			},
			onError: error => {},
			headers: {

			},
			loading: false
		}
	}

	settings() {
		return {
			api: {
				url: ''
			}
		}
	}

	/**
	 * Request general.
	 *
	 * @param method
	 * @param endpoint
	 * @param params
	 * @constructor
	 */
	Request(method, endpoint, params)
	{
		params = Object.assign({}, this.defaults, params)
		params.method=method
		params.url = params.apiBase + endpoint
		delete params.apiBase
		return http.Request(params)
	}
	
	/**
	 * Get Method
	 *
	 * @param endpoint
	 * @param params
	 * @constructor
	 */
	Get(endpoint, params)
	{
		return this.Request(http.GET, endpoint, params)
	}
	
	/**
	 * Post Method
	 *
	 * @param endpoint
	 * @param params
	 * @constructor
	 */
	Post(endpoint, params)
	{
		return this.Request(http.POST, endpoint, params)
	}
	
	/**
	 * Put Method
	 *
	 * @param endpoint
	 * @param params
	 * @constructor
	 */
	Put(endpoint, params)
	{
		return this.Request(http.PUT, endpoint, params)
	}
	
	/**
	 * Delete Method
	 *
	 * @param endpoint
	 * @param params
	 * @constructor
	 */
	Delete(endpoint, params)
	{
		return this.Request(http.DELETE, endpoint, params)
	}
}

export default BaseClient